import { autoinject } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { WorkflowAssignmentsService } from "../../../../services/workflow/workflow-assignments-service";
import { BaseWorkflowActivityAssignmentViewModel } from "../base-workflow-activity-assignment";
import { VettingService } from "../../../../services/vetting/vetting.service";

@autoinject()
export class ActivityAssignment extends BaseWorkflowActivityAssignmentViewModel {

    constructor(workflowAssignmentsService: WorkflowAssignmentsService, dialogClientService: DialogClientService, i18n: I18N, vetClientService: VettingService) {
        super(dialogClientService, i18n, workflowAssignmentsService, vetClientService);
    }
}